var Vendd = (function (Vendd) {
    'use strict';

    var doGetPageWithGetMethod = function (data, configuration, position, type) {
        var reqData =
        {
            "templateCode": LhApp.Context.Item.Template,
            "configCode": "",
            "itemId": LhApp.Context.Item.Id,
            "itemPath": LhApp.Context.Item.Path,
            "pageNumber": configuration.PageNumber,
            "pageSize": configuration.PageSize,
            "sortKey": configuration.SortKey,
            "fullPath": LhApp.Context.Item.FullPath,
            "excludeItemIds": configuration.ExcludeItemIds 

        };

		var url = (type == 'articleList' ? 'CachedServices/api/Article/GetScrolledArticleList' + (location.search) : 'CachedServices/api/Product/GetScrolledProductList' + (location.search)) + (location.search && location.search.length ? '&' : '?') + 'lang=' + LhApp.Context.Language;

        $.ajax({
            async: true,
            type: "GET",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            ContentType: 'application/json; charset=UTF-8',
            url: url,
            data: (reqData),
            success: function (response) {
                response.success ? onSuccess(response.data) : onFailure(response.data);
            },
            failure: function (ex) {
                onFailure(ex);
            }
        });

        function onSuccess(response) {
            var model = response ? response : onFailure(response);

            if (position === "Current") {
                Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetCurrentPageSuccess(data.list, model, position, type));
            } else {
                model.PageNumber = configuration.PageNumber;
                Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetPageSuccess(data.list, model, position, type));
                if (model.Items.length > 0 && model.Items[0].length > 1) {
                    addHistoryObject(configuration.PageNumber);
                }
            }
        };
        function onFailure(response) {
            if (position === "Current") {
                Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetCurrentPageFailure(data.list, response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetNextPageFailure(data.list, response));
            }
        };
    }

    var addHistoryObject = function (pageNumber) {

        if (history.pushState) {

			var querystring = window.location.pathname + (window.location.pathname.slice(-1) != "/" ? "/" : ""),
				pager = $('.x-pager[data-page-count]'),
				pageCount = pager.length ? (parseInt(pager.attr('data-page-count')) || 0) : 0,
        		pageText = pageNumber > 1 ? "p" + pageNumber + "/" : "";

            if (!(/\/P\d+\//i.test(querystring))) {
                querystring = querystring + pageText;
            } else {
                querystring = querystring.replace(/\/P\d+\//i, "/" + pageText);
            }

            var stateObject = {};
            var url = window.location.protocol
                + "//"
                + window.location.host
                + querystring
                + window.location.search;
			if (window.location.url !== url) {
				var prev = $("head link[rel=prev]");
				var next = $("head link[rel=next]");
				var prevLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber - 1) + "$2");
				var nextLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber + 1) + "$2");
				if (prev) {
					if (pageNumber > 1) {
						prev.attr("href", prevLink);
					} else {
						prev.remove();
					}
				} else if (pageNumber > 1) {
					$("head").append("link rel=\"prev\" href=\"" + prevLink + "\" />");
				}
				if (next) {
					if (pageNumber < pageCount) {
						next.attr("href", nextLink);
					} else {
						next.remove();
					}
				} else if (pageNumber < pageCount) {
						$("head").append("link rel=\"next\" href=\"" + nextLink + "\" />");
				}
				history.replaceState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
			}
        }

    }


    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetNextPage, Vendd.ScrollList, function (envelope) {

        if (envelope.message.data.serviceConfiguration == undefined || envelope.message.data.serviceConfiguration == '') return;

        var configuration = JSON.parse(envelope.message.data.serviceConfiguration);
        var nextPage = parseInt($(envelope.message.data.list).attr('data-next-page')),
    		totalPages = parseInt($(envelope.message.data.list).attr('data-total-pages'));
        if (nextPage > 1) {
            configuration.PageNumber = nextPage;
            $(envelope.message.data.list).attr('data-next-page', nextPage + 1);
            $(envelope.message.data.list).attr('data-current-page', nextPage);
            if (nextPage <= totalPages) {
                doGetPageWithGetMethod(envelope.message.data, configuration, "BottomOfList", envelope.message.data.type);
            } else {
                Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetNextPageFailure(envelope.message.data.list, { data: '{}' }));
            }
        } else {
            Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetNextPageFailure(envelope.message.data.list, { data: '{}' }));
        }

    });

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPreviousPage, Vendd.ScrollList, function (envelope) {

        if (envelope.message.data.serviceConfiguration == undefined || envelope.message.data.serviceConfiguration == '') return;

        var configuration = JSON.parse(envelope.message.data.serviceConfiguration);
        var previousPage = parseInt($(envelope.message.data.list).attr('data-previous-page')),
    		totalPages = parseInt($(envelope.message.data.list).attr('data-total-pages'));
        configuration.PageNumber = previousPage;
        $(envelope.message.data.list).attr('data-previous-page', previousPage - 1);
        $(envelope.message.data.list).attr('data-current-page', previousPage);
        if (previousPage >= 1) {
            doGetPageWithGetMethod(envelope.message.data, configuration, "TopOfList", envelope.message.data.type);
        } else {
            Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetNextPageFailure(envelope.message.data.list, { data: '{}' }));
        }
    });

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetCurrentPage, Vendd.ScrollList, function (envelope) {

        var configuration = (envelope.message.data.serviceConfiguration != "") ? JSON.parse(envelope.message.data.serviceConfiguration) : "";

        var currentPage = parseInt($(envelope.message.data.list).attr('data-current-page'));

        if (currentPage > 0 && configuration != "") {
            configuration.PageNumber = currentPage;

            Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetCurrentPageSuccess(envelope.message.data, window.jsonArr, "Current", envelope.message.data.type));
        } else {
            Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetCurrentPageFailure(envelope.message.data.list, { data: '{}' }));
        }

    });

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListData, Vendd.ScrollList, function (envelope) {
        Vendd.Service.call({
            url: 'EcomService.svc/GetProductListData',
            data: {
                variantIds: envelope.message.data.itemIds
            },
            onSuccess: function (res) {
                if (res.success) {
                    Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetClientProductListDataSuccess(res.data));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.ScrollList, new Vendd.ScrollList.Messages.GetClientProductListDataFailure(res.data));
                }
            }
        });
    });

    return Vendd;

})(Vendd || {});
